import { Callback } from '@src/lit/store/state.js';
import { LitElement } from 'lit';
import { TemplatingMixin } from '@common/lit/mixins/TemplatingMixin.js';
import { TriggerEventMixin } from '@common/lit/mixins/TriggerEventMixin.js';
import { TemplateTheme } from '@common/lit/TemplateResolver.js';
import * as templates from '@src/components/templates/index.js';
import { config } from '@src/config/index.js';
import { configStore } from '@src/store/index.js';

export class BaseComponent extends TemplatingMixin(TriggerEventMixin(LitElement, config.componentTagName), configStore.theme, templates) {
  constructor() {
    super();
    // This is important to support multiple themes (occl/tefOne).
    // If the theme gets changed in the configStore we must re-initialize the TemplateResolver,
    // otherwise it would stay on the theme default (which is "occl" here)
    const callback = (_: string, theme: TemplateTheme) => { this.setTemplatingTheme(theme); };
    configStore.subscribe((callback as Callback), 'theme');
  }
}
